import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchChatsAndContacts() {
      return new Promise((resolve, reject) => {
        axios
          .get('/apps/chat/chats-and-contacts')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getProfileUser() {
      return new Promise((resolve, reject) => {
        axios
          .get('/apps/chat/users/profile-user')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getReply(ctx, { messages }) {
      return new Promise((resolve, reject) => {
        axios
          .post('https://api.openai.com/v1/chat/completions', {
            model: 'gpt-3.5-turbo',
            messages: [
              {
                role: 'system',
                content: "Kamu adalah asisten personal bayi, parenting, ibu hamil dan menyusui sangat mengerti mitos dan fakta mengenai bayi dan kehamilan terutama informasi yang ada di indonesia. Kamu bekerja untuk Miniapoly dalam menjawab pertanyaan-pertanyaan pengguna aplikasi. Kamu berbahasa indonesia dan memanggil pengguna aplikasi dengan sebutan 'Moms'. Kamu menggunakan bahasa yang tidak formal. Gunakan kata 'Mini' sebagai kata ganti 'Saya'. Sapa pengguna aplikasi dengan menanyakan apa yang ingin mereka tanyakan hari ini. Kamu selalu berusaha menjawab dengan satu atau dua kalimat saja. Dan kamu tidak memberikan referensi apabila pengguna aplikasi tidak menanyakannya. Apabila ada yang ingin membeli produk, kamu bisa mereferensikan produk dari Miniapoly. Gantikan kata 'dia' sebagai kata ganti bayi dengan sebutan si kecil. Tolak dengan sopan apabila ada yang menanyakan diluar bayi, ibu hamil, parenting dan menyusui.",
              },
              {
                role: 'user', content: 'Namaku adalah Alika. siapa namamu?',
              },
              ...messages,
              // {
            //   role: 'assistant',
            //   content: 'Hi dendy, aku mini',
            // },
            // {
            //   role: 'user', content: 'apakah kamu masih ingat namaku?',
            // },
            ],
          }, {
            headers: {
              Authorization: 'Bearer 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',
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getChat(ctx, { userId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/apps/chat/chats/${userId}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    sendMessage(ctx, { contactId, message, senderId }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/apps/chat/chats/${contactId}`, { message, senderId })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
